var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4142 10.4142C14 9.82843 14 8.88562 14 7V5C14 3.11438 14 2.17157 13.4142 1.58579C12.8285 1 11.8856 1 10 1H8.00003C6.11441 1 5.1716 1 4.58582 1.58579M5 14H7C8.88562 14 9.82843 14 10.4142 13.4142C11 12.8284 11 11.8856 11 10V8C11 6.11438 11 5.17157 10.4142 4.58579C9.82843 4 8.88562 4 7 4H5C3.11438 4 2.17157 4 1.58579 4.58579C1 5.17157 1 6.11438 1 8V10C1 11.8856 1 12.8284 1.58579 13.4142C2.17157 14 3.11438 14 5 14Z",
    stroke: "#00205E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopied);
export default __webpack_public_path__ + "static/media/copied.cb02220db0721803759897911935860d.svg";
export { ForwardRef as ReactComponent };